import { EntityConfig } from "../..";
import { useFormType } from "../../form/hooks/useForm";
import { OperacoesConfig } from "./Operacoes/OperacoesConfig";

export const PecasTableConfig: EntityConfig = [

    {
        id: 'id',
        label: 'Id',
        type: 'text',
        nonEditable: true
    },
    {
        id: 'reference',
        label: 'Referência',
        type: 'text',
        filterable: true
    },
    {
        id: 'amount',
        label: 'Quantidade',
        type: 'number',
    },
    {
        id: 'material',
        label: 'Material',
        type: 'multi-select',
        displayFunction: (material: any) => {
            return material?.value?.reference || material?.reference;
        } ,
        filterable: true
    },
    {
        id: 'operacoes',
        label: 'Operações',
        type: 'multiple-create',
        options: {
            name: 'Operações',
            route: 'operacoes',
            ref: 'operacoes',
            value: 'id',
            label: 'reference',
            subFormConfig: OperacoesConfig,
            nestPathGetter: (form: useFormType | undefined, i: number, parentIndex: number) => {
                if (!form?.state['pecas']) {
                    return form?.state['operacoes'][i];
                };
                
                if (form?.state['pecas'][parentIndex]['operacoes']) {
                    return form?.state['pecas'][parentIndex]['operacoes'][i]
                }

                return null;
            }

        }
    }

]

